import { useEffect } from 'react';
const useFocusElementOnExit = (element) => {
    useEffect(() => {
        return () => {
            if (element) {
                element.tabIndex = -1;
                element.focus();
            }
        };
    }, [element]);
};
export default useFocusElementOnExit;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRm9jdXNFbGVtZW50T25FeGl0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvdHJhbnNhY3Rpb24vVHJhbnNhY3Rpb25GaWx0ZXIvU2VhcmNoUmVzZXRCdXR0b25zL3VzZUZvY3VzRWxlbWVudE9uRXhpdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sT0FBTyxDQUFDO0FBRWxDLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxPQUEyQixFQUFFLEVBQUU7SUFDMUQsU0FBUyxDQUFDLEdBQUcsRUFBRTtRQUNYLE9BQU8sR0FBRyxFQUFFO1lBQ1IsSUFBSSxPQUFPLEVBQUUsQ0FBQztnQkFDVixPQUFPLENBQUMsUUFBUSxHQUFHLENBQUMsQ0FBQyxDQUFDO2dCQUN0QixPQUFPLENBQUMsS0FBSyxFQUFFLENBQUM7WUFDcEIsQ0FBQztRQUNMLENBQUMsQ0FBQztJQUNOLENBQUMsRUFBRSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7QUFDbEIsQ0FBQyxDQUFDO0FBRUYsZUFBZSxxQkFBcUIsQ0FBQyJ9